import {HistoryStep} from "./historyStep";
import {HistoryController, IHistoryStepWithSelObs} from "./historyController";
import {CONSTANTS} from "../meta_data";
import {EventVerteiler} from "../../global/eventVerteiler";
import {SELOBEVENTNAMES} from "../../global/GlobalEventnames";

export class HistoryStepSelObInserted extends HistoryStep implements IHistoryStepWithSelObs {
    private currentSelObId;
    private selOb;
    private cloneIdsBeforeUndo;
    private zIndexBeforeUndo;

    constructor(historyController: HistoryController, parameters) {
        if (typeof (parameters.type) !== "string") {
            parameters.type = "selObInserted";
        }
        super(historyController, parameters);
        this.currentSelObId = parameters.selOb.id;
        this.selOb = parameters.selOb.clone(true);

        this.cloneIdsBeforeUndo = null; //noch nicht vorhanden zu diesem Zeitpunkt!
    }

    undo() {
        const $this = this;
        this.controller.restoreCameraAndModelSettings(this.viewDetails);
        if (this.cloneIdsBeforeUndo === null) {
            this.cloneIdsBeforeUndo = this.controller.getCloneIds(this.currentSelObId).slice();
        }
        this.zIndexBeforeUndo = this.controller.selObController.getZIndexOfSelOb(this.selOb.id);
        this.busy();
        setTimeout(
            function () {
                $this.controller.selObController.deleteSelOb($this.currentSelObId);
                $this.noLongerBusy();
            }
            , CONSTANTS.UNDO_DELAY
        );

    }

    redo() {
        const $this = this;
        this.controller.restoreCameraAndModelSettings(this.viewDetails);
        this.busy();
        setTimeout(
            function () {
                $this.controller.selObController.insertSelObFromStorage($this.selOb.clone(true), $this.zIndexBeforeUndo);
                $this.currentSelObId = $this.selOb.id;
                EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, $this.selOb.id);
                $this.createCloneCreationWaiter(
                    $this.selOb.id,
                    $this.cloneIdsBeforeUndo.length,
                    function (newCloneIds) {
                        $this.controller.replaceIds($this.cloneIdsBeforeUndo, newCloneIds);
                    }
                );
                $this.noLongerBusy();
            },
            CONSTANTS.UNDO_DELAY);
    }

    replaceId(origId, newId) {
        const arrays = [this.selOb.cloneIds];
        if (this.cloneIdsBeforeUndo !== null) {
            arrays.push(this.cloneIdsBeforeUndo);
        }
        if (this.selOb.id === origId) {
            this.selOb.id = newId;
        }
        if (this.currentSelObId === origId) {
            this.currentSelObId = newId;
        }
        for (let i = 0, lenI = arrays.length; i < lenI; i++) {
            arrays[i] = HistoryStep.replaceValueInArray(origId, newId, arrays[i]);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cloneWasDeleted(origId, newId) {
        //do nothing
    }
}